import React from "react";
import styles from "./index.module.scss";
import { ResetIcon } from "../../../assets/Logos/Icons";

const ResetFilterButton = ({ isActive, handleReset, visibility }) => {
  return visibility ? (
    <button className={styles.button} onClick={handleReset && handleReset}>
      <ResetIcon />
    </button>
  ) : ""
};

export default ResetFilterButton;
